<template>
  <li>
    <div>
      <i
        v-if="tree.children && tree.children.length > 0"
        :class="['fas fa-solid', tree.expand ? 'fa-chevron-down' : 'fa-chevron-right', 'node-children']"
        @click.stop="toggle"
      />

      <i v-else class="fas fa-solid fa-minus no-children"></i>

      <span
        :class="{'check': tree.unpay > 0}"
        @mouseover="mouseover($event, tree)"
        @mouseout="mouseout($event, tree)"
        @click="nodeClick($event, tree)"
      >
        <!-- 第{{ tree.generations }}代 - {{ tree.name }}({{ tree.number }}：{{ tree.rank }}) -->
        {{ tree.label }}
      </span>
    </div>

    <ul v-show="tree.expand" v-if="tree.children && tree.children.length > 0">
      <tree-list v-for="(children, index) in tree.children" :tree="children" :key="index" />
    </ul>
  </li>
</template>

<script>

export default {
  name: 'TreeList',
  props: {
    tree: {
      type: Object,
      required: false,
      default: {}
    }
  },
  data () {
    return {
      open: false
    }
  },
  mounted() {

  },
  methods: {
    // 階層開關
    toggle() {
      if (this.tree.children && this.tree.children.length > 0) {
        this.tree.expand = !this.tree.expand;
      }
    },
    // 滑鼠移入
    mouseover(e, data) {
      this.$root.$emit('on-mouseover', e, data);
    },
    // 滑鼠移出
    mouseout(e, data) {
      this.$root.$emit('on-mouseout', e, data);
    },
    // 點擊
    nodeClick(e, data) {
      this.$root.$emit('on-click', e, data);
    }
  }
}
</script>

<style lang="scss" scoped>
ul {
  padding-left: 20px;
  li {
    list-style: none;
    position: relative;
    &:before {
      content: "";
      position: absolute;
      left: -12px;
      border-top: 1px solid #000;
      top: 16px;
      width: 8px;
      height: 0;
    }
    &:after {
      content: "";
      position: absolute;
      left: -12px;
      border-left: 1px solid #000;
      height: 100%;
      width: 0px;
      top: 2px;
    }
    &:last-child::after {
      height: 15px;
    }
    > div {
      height: 30px;
      display: flex;
      align-items: center;
      white-space: nowrap;
      i.node-children {
        cursor: pointer;
        margin-right: 10px;
      }
      i.no-children {
        font-size: 10px;
        margin-right: 10px;
      }
      .check {
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/common/TreeList.vue